import createSagaMiddleware from 'redux-saga';
import { watcherSagas } from "../redux/Redux.sagas.index";

const sagaMiddleware = createSagaMiddleware();

const sagas = {
  ...watcherSagas,
};

// when calling saga, pass getFirebase
const initSagas = () => Object.values(sagas).map(saga => sagaMiddleware.run(saga));

export {
  sagaMiddleware,
  initSagas,
}
